import axios from '@fuse/utils/axios';
import {yupResolver} from '@hookform/resolvers/yup';
import * as yup from 'yup'
import { Button, Icon, IconButton, makeStyles, Modal, TextField } from '@material-ui/core';
import React from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import useToast from '@fuse/hooks/useToast';

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
}))

function DepartmentDialog(props) {

    const classes = useStyles()
    const dispatch = useDispatch()
    const toast = useToast(dispatch)

    const schema = yup.object({
        department_name: yup.string().required('department is required!'),
    })

    const defaultValues = {
        department_name: ''
    }

    const { 
        control, 
        formState:{errors: statusFormErrors}, 
        handleSubmit: statusFormSubmit, 
        reset: statusFormReset 
    } = useForm({
        mode: 'onChange',
        defaultValues,
        resolver: yupResolver(schema)
    });

    function manageDeptData(formData){
        const payload = {
            entity_external_platform_id: String(Math.trunc(Math.random()*20000)),
            department_name: formData.department_name,
        }

        axios.post('/department/add', payload).then(response => {
            if(response.status === 201){
                toast.error(response.data.message)
            } else {
                statusFormReset(defaultValues)
                // response.data.data.new_hardware_asset_status

                //Send newly added status value
                props.handleCloseDialog(response.data.data.new_data)
                
                toast.success('Department added successfully.')
                props.getDepartment()
            }
        }).catch(err => {
            console.log('234: ',err);
            toast.error(err.response.data.data)
        })

    }

    function statusFormErrorData(error){
        console.log('statusFormErrorData: ',error);
    }


    return (
        <Modal
            open={props.open}
            // onClose={()=>{
            //     statusFormReset(defaultValues)
            //     // props.handleCloseDialog()
            // }}
            className={classes.modal}
        >
            <div style={{width:700, backgroundColor: 'white', borderRadius:9,display:'flex', flexDirection:'column', padding:'20px'}}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems:'center' }}>
                    <h1>Add Department</h1>
                    <IconButton onClick={()=>{
                        statusFormReset(defaultValues)
                        props.handleCloseDialog()
                    }}>
                        <Icon>close</Icon>
                    </IconButton>
                </div>

                <form onSubmit={statusFormSubmit(manageDeptData, statusFormErrorData)}>
                    <div style={{backgroundColor: 'rgb(239 239 239)', borderRadius:9, padding: '15px'}}>
                        
                        <Controller
                            name="department_name"
                            className="mb-16"
                            defaultValue={''}
                            control={control}
                            render={({ field }) => (
                                <>
                                    <TextField
                                        {...field}
                                        variant='outlined'
                                        label='Department Name'
                                        required
                                        // fullWidth
                                        // error={!!statusFormErrors.status_name}
                                        // helperText={statusFormErrors?.status_name?.message}
                                        FormHelperTextProps={{
                                            style: {marginLeft : 0}
                                        }}
                                        style={{ marginBottom: '10px', width: '100%',background: 'white' }}
                                    />
                                </>
                            )}
                        />
                    </div>
                    <div style={{display:'flex',gap:'20px',paddingTop:'20px'}}>
                        <Button
                            variant='contained' color='primary' size='small' style={{ borderRadius: '4px' }}
                            type='submit'
                        >Add</Button>
                        <Button 
                            variant='outlined' color='primary' size='small' style={{ borderRadius: '4px' }}
                            onClick={()=>{
                                statusFormReset(defaultValues)
                                props.handleCloseDialog()
                            }}
                        >Cancel</Button>
                    </div>
                </form>
            </div>

        </Modal>
    )
}

export default DepartmentDialog
